export interface IMentorEducationChoice {
    id: number,
    description: string
}